import { types as t, Instance, SnapshotOut } from 'mobx-state-tree';
import { ModelV2 as Model } from '~/mst/models/abstract/model';

const DevicePofileModel = t.compose(
  t.model({
    name: t.maybeNull(t.string),
    group: t.maybeNull(t.string),
    description: t.maybeNull(t.string),
    status_name: t.frozen(),
    parameters: t.maybeNull(t.frozen()),
    // Air quality score weights keyed by path
    aq_index: t.maybeNull(t.frozen()),
    ranges: t.frozen()
  }),
  Model
);

export interface IDevicePofileModel extends Instance<typeof DevicePofileModel> {}
export interface IDevicePofileModelSnapshotOut extends SnapshotOut<typeof DevicePofileModel> {}

export default DevicePofileModel;
